"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
// import _get from 'lodash/get';
var ClientReportToolbar = /*#__PURE__*/function (_Component) {
  _inherits(ClientReportToolbar, _Component);
  function ClientReportToolbar() {
    _classCallCheck(this, ClientReportToolbar);
    return _callSuper(this, ClientReportToolbar, arguments);
  }
  _createClass(ClientReportToolbar, [{
    key: "render",
    value: function render() {
      var _this = this;
      var lastHeader = (0, _last2["default"])(this.props.headerList);
      var firstHeader = (0, _first2["default"])(this.props.headerList);
      var from = '----';
      var to = '----';
      var valid = false;
      var hasFrom;
      var hasTo;
      if (!(0, _isNull2["default"])(this.props.datesOfService.from)) {
        from = _moment["default"].isMoment(this.props.datesOfService.from) ? this.props.datesOfService.from.format('MM/DD/YYYY') : (0, _moment["default"])(this.props.datesOfService.from).format('MM/DD/YYYY');
        valid = true;
        hasFrom = true;
      }
      if (!(0, _isNull2["default"])(this.props.datesOfService.to)) {
        to = _moment["default"].isMoment(this.props.datesOfService.to) ? this.props.datesOfService.to.format('MM/DD/YYYY') : (0, _moment["default"])(this.props.datesOfService.to).format('MM/DD/YYYY');
        valid = true;
        hasTo = true;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].reportToolbarContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].rowOne
      }, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.heading), /*#__PURE__*/_react["default"].createElement("ul", {
        className: _style["default"].dateArea
      }, hasFrom === true && hasTo === true && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "Dates of Service:"), ' ', valid && /*#__PURE__*/_react["default"].createElement("span", null, from, " to ", to), !valid && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("i", null, "Not Started"))), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "Date Report Created:"), ' ', (0, _moment["default"])(Date.now()).format('MM/DD/YYYY')))), /*#__PURE__*/_react["default"].createElement("ul", {
        className: _style["default"].rowTwo
      }, this.props.fields.map(function (f, index) {
        if (!(0, _isEmpty2["default"])(_this.props.headerList)) {
          return /*#__PURE__*/_react["default"].createElement("li", null, _this.props.headerList.map(function (item) {
            if (item === lastHeader && item !== firstHeader) {
              return /*#__PURE__*/_react["default"].createElement("span", null, item);
            }
            if (item === firstHeader && item !== lastHeader) {
              return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
                className: _style["default"].bold
              }, f.label, ": "), ' ', /*#__PURE__*/_react["default"].createElement("span", null, item, ", "));
            }
            if (item === firstHeader && item === lastHeader) {
              return /*#__PURE__*/_react["default"].createElement("span", null, ' ', /*#__PURE__*/_react["default"].createElement("span", {
                className: _style["default"].bold
              }, f.label, ": "), /*#__PURE__*/_react["default"].createElement("span", null, item));
            }
            return /*#__PURE__*/_react["default"].createElement("span", null, item, ", ");
          }));
        }
        return '';
      }), this.props.fields.map(function (f, index) {
        if (!(0, _isNil2["default"])(f.value) && f.type !== 'list') {
          return /*#__PURE__*/_react["default"].createElement("li", {
            key: index
          }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
            className: _style["default"].bold
          }, f.label, ":"), " ", f.value));
        }
        return '';
      })));
    }
  }]);
  return ClientReportToolbar;
}(_react.Component);
ClientReportToolbar.propTypes = {
  currentClient: _propTypes["default"].object.isRequired,
  heading: _propTypes["default"].string.isRequired,
  valueFieldPath: _propTypes["default"].string,
  clientType: _propTypes["default"].string.isRequired,
  fields: _propTypes["default"].array,
  /**
   * {
   *      from: moment(),
   *      to: moment(),
   * }
   */
  datesOfService: _propTypes["default"].object,
  allSessionsNotHeldMissed: _propTypes["default"].bool,
  headerList: _propTypes["default"].array
};
ClientReportToolbar.defaultProps = {
  allSessionsNotHeldMissed: false
};
var _default = exports["default"] = ClientReportToolbar;